var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"input"}},[_c('Input',{attrs:{"preparing":_vm.preparing},on:{"asked":_vm.ask}})],1),_c('Output',{attrs:{"answer":_vm.answer,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }